import { render, staticRenderFns } from "./GridDinamico.vue?vue&type=template&id=f07ec44e"
import script from "./GridDinamico.vue?vue&type=script&lang=js"
export * from "./GridDinamico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports